var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlusRegular = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.7496 3C12.1293 3 12.4431 3.28201 12.4929 3.64808L12.4997 3.74985L12.501 11H19.754C20.1683 11 20.504 11.3358 20.504 11.75C20.504 12.1297 20.2219 12.4435 19.8558 12.4932L19.754 12.5H12.501L12.503 19.7491C12.5031 20.1633 12.1674 20.4993 11.7532 20.4993C11.3735 20.4993 11.0596 20.2173 11.0099 19.8512L11.003 19.7494L11.001 12.5H3.75195C3.33774 12.5 3.00195 12.1642 3.00195 11.75C3.00195 11.3703 3.28411 11.0565 3.65018 11.0068L3.75195 11H11.001L10.9997 3.75015C10.9997 3.33594 11.3354 3 11.7496 3Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlusRegular, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plus-regular.013ffa65.svg";
export { ForwardRef as ReactComponent };